import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'next-intl';

import { type Locale } from '@/i18n/routing';

import { FilterApi } from '@/api/domains/filters.api';

import { MovieQueryKeys } from '@/contexts/QueryContext/query.keys';

export const usePreferFilterList = () => {
  const locale = useLocale() as Locale;

  const { data, isLoading } = useQuery({
    queryKey: MovieQueryKeys.preferedFilterList(locale),
    queryFn: FilterApi.fetchPreferedFilterList,
    staleTime: Infinity,
  });

  return { filterList: data, isLoading };
};
